<ng-container *ngIf="newDesign; else oldDesign" >
  <div class="new-design">
    <nav class="breadcrumbs" aria-label="breadcrumb" [ngClass]="{'breadcrumbs--arrow': type === 'arrow', 'breadcrumbs--p0': gutter === 'p0'}">
      <div class="container">
        <ul class="breadcrumbs__list">
          <li
            *ngFor="let item of items; let last = last"
            [class.active]="last"
            class="breadcrumbs__item"
          >
            <ng-container *ngIf="!last">
              <a *ngIf="item.routerLink" [routerLink]="item.routerLink" [queryParams]="item.queryParams">{{item.title}}</a>
              <a *ngIf="item.href" [href]="item.href">{{item.title}}</a>
            </ng-container>
            <span *ngIf="last">{{item.title}}</span>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</ng-container>
<ng-template #oldDesign>
  <div class="old-design breadcrumbs breadcrumbs__list">
    <div class="breadcrumbs__links">
      <ng-container *ngFor="let item of items; trackBy: trackFn; let i = index">
        <ng-container *ngIf="i > 0">
          <span></span>
        </ng-container>
        <a *ngIf="item.routerLink" [routerLink]="item.routerLink" [queryParams]="item.queryParams" class="breadcrumbs__link">{{item.title}}</a>
        <a *ngIf="item.href" [href]="item.href" class="breadcrumbs__link">{{item.title}}</a>
        <span *ngIf="!item.href && !item.routerLink" class="breadcrumbs__link">{{item.title}}</span>
      </ng-container>
    </div>
  </div>
</ng-template>
